import { h } from 'preact';
import Image from '../utils/image';

export default ({
  title,
  image,
  description,
  ctaText,
  ctaLink,
}) => {

  const els = {
    image: (
      image && <Image src={image} classes='w-[154px]' />
    ),
    description: (description &&
      <p className='font-14'>{description}</p>
    ),
    cta: (ctaText && ctaLink &&
      <a
        href={ctaLink}
        className='cta-small link-unstyled underline pb-0.5'
      >
        {ctaText}
      </a>
    )
  }

  const hasBottomContent = els.image || els.description || els.cta;

  return (
    <div className=''>
      {title && <p className='subheading-h4 mb-2'>{title}</p>}
      {hasBottomContent && 
        <div className='flex items-center gap-x-[17px]'>
          {els.image}
          {(els.description || els.cta) && 
            <div className="flex flex-col items-start gap-y-3">
              {els.description}
              {els.cta}
            </div>
          }
        </div>
      }
    </div>
  )
}
